export default __webpack_public_path__ + "static/media/flag-morocco.c130c068.svg";